import { createRouter, createWebHistory } from "vue-router";
import MainPage from "@/views/MainPage.vue";
import SuccessPage from "@/views/SuccessPage.vue";
import ExpiredPage from "@/views/ExpiredPage.vue";
import App from "@/App.vue";

const routes = [
  {
    path: "/",
    name: "App",
    component: App,
    props: {default: true}
  },
  {
    path: "/payment",
    name: "MainPage",
    component: MainPage,
    props: {default: true}
  },
  {
    path: "/success",
    name: "SuccessPage",
    component: SuccessPage,
  },
  {
    path: "/expired",
    name: "ExpiredPage",
    component: ExpiredPage,
    props: {default: true}
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
